import { Component, Input, OnInit } from '@angular/core';
import { ProductLogicService } from '@app/logic/products';
import { take } from 'rxjs';

@Component({
    selector: 'cb-item-usage-summary-tab',
    templateUrl: './item-usage-summary-tab.component.html',
    standalone: false
})
export class ItemUsageSummaryTabComponent implements OnInit {
    @Input() public productId: number;
    public productCards: Array<any>;
    constructor(private readonly productLogicService: ProductLogicService) {}

    public ngOnInit(): void {
        this.productLogicService.getProductCards(this.productId).pipe(take(1)).subscribe({
            next: res => this.productCards = res
        });
    }
}
